import React, { useCallback, useEffect } from 'react';
import eventBus, { EventTypes } from '@ocp/event-bus';
import LoadingIndicator from '@ocp/loading-indicator';
import { useToolbarContentQuery } from '../../queries/index';
import ButtonsGroup from './ButtonsGroup';
const Toolbar = ({ classNameId, classPk, deviceType, panelMode, initValues = undefined, }) => {
    const [getData, { data, loading }] = useToolbarContentQuery();
    const fetchToolbarData = useCallback(() => {
        getData({
            variables: {
                contentIds: [`${classNameId}-${classPk}`],
                deviceType,
                panelMode,
            },
            fetchPolicy: 'cache-and-network',
        });
    }, [classNameId, classPk, deviceType, panelMode, getData]);
    useEffect(() => {
        if (!initValues) {
            fetchToolbarData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initValues]);
    const params = data ? data.contentToolbar.items[0] : initValues;
    useEffect(() => {
        const handleToggleFavorite = (event) => {
            const eventContentClassNameId = event.detail.data.classNameId;
            const eventClassPk = event.detail.data.classPk;
            if (eventContentClassNameId === classNameId && eventClassPk === classPk) {
                fetchToolbarData();
            }
        };
        if (params) {
            eventBus.on(EventTypes.ToggleFavorite, handleToggleFavorite);
        }
        return () => {
            eventBus.off(EventTypes.ToggleFavorite, handleToggleFavorite);
        };
    }, [params, classNameId, classPk, fetchToolbarData]);
    if (!params) {
        return loading ? React.createElement(LoadingIndicator, null) : null;
    }
    return (React.createElement(ButtonsGroup, { classNameId: classNameId, classPk: classPk, deviceType: deviceType, panelMode: panelMode, params: params, 
        /*
         There is ugly hack, refetch query simulation. In case when initData is available
         not possible to call useToolbarContentQuery hook
         then refetch API and apollo cache not working for that hook
        */
        onMutate: fetchToolbarData }));
};
export default Toolbar;
